<template>
  <div class="wd-flex wd-justify-between wd-items-center wd-gap-2 wd-w-full">
    <div class="wd-mr-2 wd-flex-1 wd-min-w-0">
      <div class="wd-mb-2 wd-flex wd-items-center">
        <funnow-icon class="wd-mr-1" max-width="16" height="16" :image-path="membershipLevelFlatIcon" />
        <span class="wd-mr-1 wd-text-otempsm" :class="membershipLevelColorClass">
          {{ membershipLevelName }}
        </span>
        <span class="wd-text-gray80 wd-text-otempsm wd-truncate">{{ $t('billing_fun_coin_hint') }}</span>
      </div>

      <div class="wd-flex wd-items-center wd-text-omd">
        <span class="wd-mr-2"> {{ funCoinsRewardsText }} </span>
        <funnow-icon max-width="16" :image-path="'fun_coins.svg'" />
      </div>
    </div>

    <div class="wd-text-right wd-min-w-90px">
      <p class="!wd-mb-1 wd-text-omd" :class="{ 'wd-h-4': !showFeedbackAmount }">{{ showFeedbackAmount ? funCoinsFeedbackText : '' }}</p>
      <p class="!wd-mb-0 wd-text-gray80 wd-text-otempsm">{{ funCoinsWithRateFeedbackText }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ComputedRef, Ref } from 'vue'
import FunnowIcon from '@/components/icons/funnow-icon.vue'
import { useUserInfo, useMembershipLevel } from '@/composition/useMember'
import { useFunCoins, type FunCoinData } from '@/composition/useFunCoins'

type Props = {
  funCoinSource: FunCoinData
  showFeedbackAmount?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  funCoinSource: () => ({} as FunCoinData),
  showFeedbackAmount: true,
})
const { funCoinSource } = toRefs(props)

const { userInfo } = useUserInfo()
const { membershipLevelColorClass, membershipLevelFlatIcon, membershipLevelName } = useMembershipLevel(userInfo)
const { funCoinsRewardsText, funCoinsFeedbackText, funCoinsWithRateFeedbackText } = useFunCoins(funCoinSource)
</script>
